import React, { useEffect, useState, Children } from 'react';
import classnames from 'classnames';

// utils
import { isElementOfType, sanitizeFragments } from '../../utilities/components';

//Components
import WpStep from './WpStep';

// Styles
import './WpSteps.scss';

export type DirectionType = 'vertical' | 'horizontal';
const DEFAULT_DIRECTION_TYPE = 'vertical';

export interface Props {
  children?: React.ReactNode;
  direction?: DirectionType;
  activeStepNumber?: number;
  hideDefaultNavButtons?: boolean;
  withAnimation?: boolean;
}

const WpSteps: React.FC<Props> = ({
  children,
  direction = DEFAULT_DIRECTION_TYPE,
  activeStepNumber,
  hideDefaultNavButtons = false,
  withAnimation = true,
}: Props) => {
  const [activeId, setActiveId] = useState(activeStepNumber || 1);

  useEffect(() => {
    if (activeStepNumber) setActiveId(activeStepNumber);
  }, [activeStepNumber]);

  const sanitizedChildren = children && sanitizeFragments(children);
  const childrenSteps = Children.toArray(sanitizedChildren).filter(child =>
    isElementOfType(child, [WpStep])
  ) as React.ReactElement[];

  const handleNavigateSteps = id => {
    setActiveId(id);
  };
  const count = childrenSteps.length;
  const stepContent = childrenSteps.map((child, index) => {
    const stepNumber = index + 1;
    const isLastStep = count === stepNumber;
    const isFirstStep = stepNumber === 1;
    const newProps = {
      stepNumber,
      active: activeId === stepNumber,
      completed: stepNumber < activeId,
      hideDefaultNavButtons,
      withAnimation: withAnimation,
      handleNextNavigation: isLastStep ? null : () => handleNavigateSteps(stepNumber + 1),
      handleBackNavigation: isFirstStep ? null : () => handleNavigateSteps(stepNumber - 1),
    };
    return React.cloneElement(child, newProps);
  });
  const classNamePrefix = 'WpSteps';
  const classes = classnames(classNamePrefix, `${classNamePrefix}--${direction}`);
  return <div className={classes}>{stepContent}</div>;
};

export default WpSteps;
